export const SiteAccessDenyCodes = {
  siteNotAccessible: 'SiteNotAccessible',
  siteDeleted: 'SiteDeleted',
  siteDisabled: 'SiteDisabled',
  siteReadOnly: 'SiteReadOnly',
  siteNotReportingActive: 'SiteNotReportingActive',
  insufficientPermission: 'InsufficientPermission',
  parentCustomerDisabled: 'ParentCustomerDisabled',
  parentCustomerDeleted: 'ParentCustomerDeleted',
  parentLocationDisabled: 'ParentLocationDisabled',
  parentLocationDeleted: 'ParentLocationDeleted',

  isLifecycleCode(code: string): boolean {
    return (
      code === this.siteDisabled
      || code === this.siteDeleted
      || code === this.siteReadOnly
      || code === this.siteNotReportingActive
      || code === this.parentCustomerDisabled
      || code === this.parentCustomerDeleted
      || code === this.parentLocationDisabled
      || code === this.parentLocationDeleted
    );
  },
} as const;
